import { render, staticRenderFns } from "./benefits-points-section.vue?vue&type=template&id=64737321&scoped=true"
import script from "./benefits-points-section.vue?vue&type=script&lang=js"
export * from "./benefits-points-section.vue?vue&type=script&lang=js"
import style0 from "./benefits-points-section.vue?vue&type=style&index=0&id=64737321&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64737321",
  null
  
)

export default component.exports